/* Boek-animatie in twee smaken:
   — Desktop: scroll-gestuurd. De sectie "plakt" en de vellen draaien
     mee met de scrollpositie.
   — Telefoon (of reduced motion): geen scroll-besturing. Het boek
     staat gewoon in de pagina en bladert met een tik op het boek of
     de pijltjes, met soepele CSS-overgangen. Zo blijft scrollen op
     mobiel volledig normaal en springt er niets door de adresbalk.
   Alleen de rechterpagina's zijn bedrukt, zoals het echte boek. */
(function () {
  var wrap = document.querySelector('[data-book-flip]');
  if (!wrap) return;
  var book = wrap.querySelector('[data-book]');
  var sheets = wrap.querySelectorAll('[data-sheet]');
  if (!book || sheets.length === 0) return;
  var hint = wrap.querySelector('[data-book-hint]');
  var controls = wrap.querySelector('[data-book-controls]');
  var prevBtn = wrap.querySelector('[data-book-prev]');
  var nextBtn = wrap.querySelector('[data-book-next]');
  var dotsEl = wrap.querySelector('[data-book-dots]');
  var N = sheets.length;

  function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }
  function easeInOut(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

  /* Gedeeld: zet per vel de rotatie + stapelvolgorde en de
     boek-variabelen, op basis van omslag-waardes (0 = niet, 1 = wel). */
  function applyFlips(flips, activeIndex) {
    for (var i = 0; i < N; i++) {
      var f = flips[i];
      /* echte diepte per vel: rechts ligt het bovenste vel het dichtst
         bij de kijker, links het laatst-omgeslagen vel. Safari sorteert
         3D-elementen op diepte (en negeert z-index), dus dit bepaalt
         betrouwbaar welk vel bovenop ligt. */
      var depth = ((N - i) * (1 - f) + (i + 1) * f) * 2;
      sheets[i].style.transform =
        'translateZ(' + depth.toFixed(2) + 'px) rotateY(' + (-f * 178).toFixed(2) + 'deg)';
      var z;
      if (i === activeIndex || (f > 0.02 && f < 0.98)) z = 40;
      else if (f >= 0.98) z = 10 + i;
      else z = 10 + (N - i);
      sheets[i].style.zIndex = z;
    }
    var first = flips[0];
    var last = flips[N - 1];
    book.style.setProperty('--shift', (first * 50 + last * 50).toFixed(2));
    book.style.setProperty('--tilt', (6 * (1 - first) + 6 * last).toFixed(2));
    book.style.setProperty('--spread', (first * (1 - last)).toFixed(3));
    book.style.setProperty('--pl', (first * (1 - last)).toFixed(3));
    book.style.setProperty('--pr', (1 - last).toFixed(3));
  }

  /* ---------------- handmatige modus (telefoon) ---------------- */
  var manualMq = window.matchMedia('(max-width: 760px)');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var state = 0;            /* aantal omgeslagen vellen: 0 = voorkant, N = achterkant */
  var settleTimer = null;

  function renderDots() {
    if (!dotsEl) return;
    var html = '';
    for (var i = 0; i <= N; i++) {
      html += '<span class="book-flip__dot' + (i === state ? ' book-flip__dot--on' : '') + '"></span>';
    }
    dotsEl.innerHTML = html;
  }

  function setState(next, animate) {
    var prev = state;
    state = clamp(next, 0, N);
    var flips = [];
    for (var i = 0; i < N; i++) flips.push(i < state ? 1 : 0);
    var active = state > prev ? prev : state; /* het vel dat nu draait */
    applyFlips(flips, animate ? active : -1);
    if (animate && settleTimer) clearTimeout(settleTimer);
    if (animate) {
      settleTimer = setTimeout(function () { applyFlips(flips, -1); }, 760);
    }
    if (prevBtn) prevBtn.disabled = state === 0;
    if (nextBtn) nextBtn.disabled = state === N;
    renderDots();
  }

  /* slot: één omslag tegelijk — nieuwe tikken tijdens een lopende
     animatie worden genegeerd, zodat er nooit vellen over elkaar heen
     buitelen */
  var busyUntil = 0;
  function tryState(next) {
    var now = Date.now();
    if (now < busyUntil) return;
    if (next === state || next < 0 || next > N) return;
    busyUntil = now + 780;
    setState(next, true);
  }

  function startManual(startState) {
    wrap.classList.add('book-flip-wrap--manual');
    if (controls) controls.hidden = false;
    if (hint) hint.textContent = 'Tik op het boek om te bladeren';
    if (prevBtn) prevBtn.addEventListener('click', function () { tryState(state - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { tryState(state + 1); });
    book.addEventListener('click', function () {
      tryState(state === N ? 0 : state + 1);
    });

    /* vegen: naar links = volgende pagina, naar rechts = vorige */
    var touchX = null, touchY = null;
    book.addEventListener('touchstart', function (e) {
      if (e.touches.length === 1) {
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
      }
    }, { passive: true });
    book.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      var dy = e.changedTouches[0].clientY - touchY;
      touchX = touchY = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        tryState(dx < 0 ? state + 1 : state - 1);
      }
    }, { passive: true });

    setState(startState, false);
  }

  if (reduce) {
    /* stilliggend open op de vragen-spread, wel gewoon te bladeren */
    startManual(N - 1);
    return;
  }
  if (manualMq.matches) {
    startManual(0);
    return;
  }

  /* ---------------- scroll-modus (desktop) ---------------- */
  var START = 0.05, END = 0.9;
  var flipDur = (END - START) / (N + (N - 1) * 0.62);
  var restDur = flipDur * 0.62;
  var TIMELINE = [];
  var t = START;
  for (var i = 0; i < N; i++) {
    TIMELINE.push({ start: t, end: t + flipDur });
    t += flipDur + restDur;
  }

  function applyProgress(progress) {
    var flips = [];
    for (var i = 0; i < N; i++) {
      var seg = TIMELINE[i];
      flips.push(easeInOut(clamp((progress - seg.start) / (seg.end - seg.start), 0, 1)));
    }
    applyFlips(flips, -1);
    if (hint) hint.style.opacity = progress > 0.05 && progress < 0.95 ? '0' : '1';
  }

  var ticking = false;
  function update() {
    ticking = false;
    /* clientHeight is stabiel op mobiel (verandert niet mee met de
       adresbalk), dus geen sprongen tijdens het scrollen */
    var vh = document.documentElement.clientHeight;
    var rect = wrap.getBoundingClientRect();
    var total = rect.height - vh;
    if (total <= 0) { applyProgress(0.62); return; }
    applyProgress(clamp(-rect.top / total, 0, 1));
  }
  function onScroll() {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();
